import { NavbarContent } from './NavbarContent';

export const NavBar = () => {
    return (
        <nav className="nav">
            <div className="nav__inner">
                <NavbarContent />
            </div>
        </nav>
    );
};
